/**
 * my_follow_ups — every vertical, default OFF (api#1064). The reader's own
 * open follow-ups, grouped by the API's due/overdue answers; see MyFollowUps.
 */
import { MyFollowUpsList } from '../../sales/MyFollowUps';
import { WidgetPanel } from '../WidgetPanel';

export default function MyFollowUpsWidget() {
  return (
    <WidgetPanel widgetKey="my_follow_ups" eyebrow="Sales" title="My Follow-ups" link={{ label: 'Meetings', to: '/sales/meetings' }}>
      <div className="p-4">
        <MyFollowUpsList />
      </div>
    </WidgetPanel>
  );
}
